/* The Draffte Passport logo mark — used in nav bars, the footer and auth
   headers. Replaces the old violet placeholder square. Pass the size + rounding
   you want via `className` (e.g. "h-8 w-8 rounded-lg"). */
export function BrandMark({ className = "h-8 w-8 rounded-lg" }: { className?: string }) {
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img src="/draffte-logo.png" alt="Draffte" className={`${className} object-cover`} />
  );
}
